import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { HTTP_STATUS } from 'src/app/app-shared-elements/_enums/status.enum';
import { ResendEmailCode } from '../_store/actions/auth.actions';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ApiResponse } from 'src/app/app-shared-elements/_interfaces/ApiRequest';
import { AuthState } from '../_store/states/auth.state';

@Component({
    selector: 'app-confirm-auth',
    templateUrl: './confirm-auth.component.html',
    styleUrls: ['./confirm-auth.component.scss'],
    standalone: false,
})
export class ConfirmAuthComponent implements OnInit, OnDestroy {

    authLoginStatus$: Observable<ApiResponse> = this.store.select(AuthState.getAuthStatus);

    @Input() email: string;
    @Input() data: { status: HTTP_STATUS; remainingTimeSeconds: number; sessionToken: string };
    @Output() confirmCodeEvent = new EventEmitter<{ code: string; isRemember: boolean }>();
    @Output() closeEvent = new EventEmitter<void>();

    httpStatus = HTTP_STATUS;

    timerMinutes: number = 30;
    timerSeconds: number = 0;
    private totalTimerSeconds: number = 0;
    public timerInterval: any;

    resendTimer = 0;
    private resendTimerInterval: any;
    isStartResendTimer = false;
    code: string = '';

    isRemember = false;

    readonly resentCodeIcon = './assets/design/icons/auth/resent-code.svg';

    private destroy: Subject<boolean> = new Subject<boolean>();

    constructor(private store: Store) {

        this.authLoginStatus$.pipe(takeUntil(this.destroy)).subscribe((data) => {

            console.log(data);
            this.data = data as { status: HTTP_STATUS; remainingTimeSeconds: number; sessionToken: string };

            if (data && (data.status === HTTP_STATUS.RATE_LIMIT_TWO_FACTOR_ATTEMPTS || data.status === HTTP_STATUS.TWO_FACTOR_EMAIL_COOLDOWN || data.status === HTTP_STATUS.RATE_LIMIT_LOGIN_ATTEMPTS)) {
                this.startTimer();
            }
            
        });

    }

    ngOnInit() {

    }

    ngOnDestroy() {
        this.stopTimer();
        this.stopResendTimer();
        this.destroy.next(true);
        this.destroy.complete();
    }

    startTimer(): void {
        this.totalTimerSeconds = this.data?.remainingTimeSeconds || 0;
        this.updateTimerDisplay();

        this.timerInterval = setInterval(() => {
            if (this.totalTimerSeconds > 0) {
                this.totalTimerSeconds--;
                this.updateTimerDisplay();
            } else {
                this.stopTimer();
            }
        }, 1000);
    }

    private updateTimerDisplay(): void {
        this.timerMinutes = Math.floor(this.totalTimerSeconds / 60);
        this.timerSeconds = this.totalTimerSeconds % 60;
    }

    stopTimer(): void {
        if (this.data?.status === HTTP_STATUS.RATE_LIMIT_LOGIN_ATTEMPTS && this.timerInterval) {
            this.closeEvent.emit();
            clearInterval(this.timerInterval);
            this.timerInterval = null;
            return;
        }
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
    }

    resetTimer(): void {
        this.stopTimer();
        this.startTimer();
    }

    getFormattedTime(): string {
        const minutes = this.timerMinutes.toString().padStart(2, '0');
        const seconds = this.timerSeconds.toString().padStart(2, '0');
        return `${minutes}:${seconds}`;
    }

    startResendTimer(): void {
        this.isStartResendTimer = true;
        this.resendTimer = this.data?.remainingTimeSeconds / 60 || 60;

        this.resendTimerInterval = setInterval(() => {
            this.resendTimer--;
            if (+this.resendTimer === 0) {
                this.stopResendTimer();
                this.isStartResendTimer = false;
                return;
            }
        }, 1000);
    }

    stopResendTimer(): void {
        clearInterval(this.resendTimerInterval);
        this.resendTimerInterval = null;
        this.isStartResendTimer = false;
    }

    async resendEmailCode(): Promise<void> {
        this.startResendTimer();
        await this.store.dispatch(new ResendEmailCode(this.data.sessionToken)).toPromise();
    }

    async confirmCode(): Promise<void> {
        const data = {
            code: this.code,
            isRemember: this.isRemember,
        };
        this.confirmCodeEvent.emit(data);
    }
}
